/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-shadow */
/* eslint-disable no-prototype-builtins */
/* eslint-disable camelcase */
/* eslint-disable radix */
/* eslint-disable no-unused-vars */
import moment from 'moment'
import useIPA from '@/auth/jwt/useDevice'
import router from '@/router/index'

// initial state
const state = () => ({
  trend: [],
  perPage_Temperature: 10,
  pageOptions_Temperature: [3, 5, 10],
  totalRows_Temperature: 1,
  sortOptions_Temperature: [],
  fields_Temperature: [
    { key: 'recorded_at', label: 'datetime', sortable: true },
    { key: 'value', label: 'value' },
  ],
  perPage_Battery: 5,
  pageOptions_Battery: [3, 5, 10],
  totalRows_Battery: 1,
  sortOptions_Battery: [],
  fields_Battery: [
    { key: 'datetime', label: 'datetime', sortable: true },
    { key: 'value', label: 'value' },
  ],
  historical_temperature_houly: [],
  historical_temperature: [],
  historical_temperature_full: [],
  historical_battery_houly: [],
  historical_battery: [],
  deviceoptions: [],
  devicetypeoptions: [],
  deviceList: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    totalActive: 1,
    totalOffline: 1,
    totalError: 1,
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'locations.areas.sites.name', label: 'Sites → Name', sortable: true },
      { key: 'locations.areas.sites.region_regencies.name', label: 'Regency Name', sortable: true },
      { key: 'locations.areas.sites.region_provinces.name', label: 'Province Name', sortable: true },
      { key: 'code', label: 'Code', sortable: false },
      { key: 'value', label: 'Value', sortable: false },
      { key: 'value_power', label: 'Value Power', sortable: false },
      { key: 'signal_strength', label: 'Signal Strength', sortable: false },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'is_offline_alarm', label: 'offline alarm' },
      { key: 'is_over_limit_max', label: 'over limitmax' },
      { key: 'is_over_limit_min', label: 'over limitmin' },
      { key: 'is_power_disconnect', label: 'power disconnect' },
      { key: 'is_power_shutdown', label: 'power shutdown' },
      { key: 'is_probe_fault', label: 'probe fault' },
      { key: 'is_power_low', label: 'power low' },
      { key: 'serial_number', label: 'device SN', sortable: true },
      { key: 'provider_cards.msisdn', label: 'msisdn', sortable: false },
      { key: 'device_status', label: 'Device Status', sortable: true },
      { key: 'last_online_device', label: 'last online', sortable: true },
      { key: 'last_send_data', label: 'Last Send Data', sortable: false },
      { key: 'device_types.name', label: 'Type', sortable: false },
      { key: 'note', label: 'Note' },
      { key: 'action', label: 'action' },
    ],
    items: [],
  },
  deviceListInstallation: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    totalActive: 1,
    totalOffline: 1,
    totalError: 1,
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'code', label: 'device code', sortable: true },
      { key: 'serial_number', label: 'Serial Number', sortable: true },
      { key: 'value', label: 'Value', sortable: true },
      { key: 'value_power', label: 'Power', sortable: true },
      { key: 'signal_strength', label: 'Signal Strength', sortable: true },
      { key: 'installator.name', label: 'installator name', sortable: true },
      { key: 'installation_date', label: 'Installation Date', sortable: true },
      { key: 'approved_at', label: 'Approved Date', sortable: true },
      { key: 'installation_status', label: 'Status', sortable: true },
      { key: 'locations.areas.sites.name', label: 'Sites Name', sortable: false },
      { key: 'locations.areas.sites.region_provinces.name', label: 'Province Name', sortable: false },
      { key: 'locations.areas.sites.region_regencies.name', label: 'Regency Name', sortable: false },
      { key: 'device_status', label: 'Device Status', sortable: true },
      { key: 'installation_note', label: 'installation note', sortable: true },
      { key: 'action', label: 'action' },
    ],
    items: [],
  },
  inventory: {
    perPage: 10,
    pageOptions: [10, 25, 50],
    totalRows: 1,
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'name', label: 'name', sortable: true },
      { key: 'area_name', label: 'area name', sortable: true },
      { key: 'location_name', label: 'location name', sortable: true },
      { key: 'device_sum', label: 'device total', sortable: true },
      { key: 'device_sum_active', label: 'device active', sortable: true },
      {
        key: 'device_sum_deactive',
        label: 'device deactive',
        sortable: true,
      },
      { key: 'action', label: 'action' },
    ],
    items: [],
  },
  report: {
    perPage: 10,
    pageOptions: [10, 25, 50],
    totalRows: 1,
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'area_name', label: 'area name', sortable: true },
      { key: 'device_code', label: 'device code', sortable: true },
      {
        key: 'device_installation_date',
        label: 'device installation date',
        sortable: true,
      },
      { key: 'device_msisdn', label: 'device msisdn', sortable: true },
      { key: 'device_name', label: 'device name', sortable: true },
      {
        key: 'device_serial_number',
        label: 'device serial number',
        sortable: true,
      },
      { key: 'device_status', label: 'device status', sortable: true },
      { key: 'device_type_name', label: 'device type name', sortable: true },
      { key: 'district_name', label: 'district name', sortable: true },
      { key: 'location_name', label: 'location name', sortable: true },
      { key: 'province_name', label: 'province name', sortable: true },
      { key: 'regency_name', label: 'regency name', sortable: true },
      { key: 'site_name', label: 'site name', sortable: true },
    ],
    items: [],
  },
  device_list: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'locations.areas.sites.name', label: 'Site Name', sortable: true },
      { key: 'code', label: 'Device Code', sortable: true },
      { key: 'serial_number', label: 'Serial Number', sortable: true },
      { key: 'value', label: 'Value', sortable: true },
      { key: 'last_send_data', label: 'Last Send Data', sortable: true },
      { key: 'smile_connection_status', label: 'Smile Connection Status', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'device_status', label: 'Device Status', sortable: false },
    ],
    items: [],
  },
  reportMHD: {
    perPage: 10,
    pageOptions: [10, 25, 50],
    totalRows: 1,
    sortOptions: [],
    fields: [
      { key: 'recorded_at', label: 'Date Time', sortable: true },
      { key: 'ph', label: 'PH', sortable: true },
      { key: 'nh3', label: 'NH3', sortable: true },
      { key: 'cod', label: 'COD', sortable: true },
      { key: 'tss', label: 'TSS', sortable: true },
      { key: 'debit', label: 'Debit', sortable: true },
    ],
    items: [],
    fullItems: [],
  },
  dashboard: { sparing: [], items: [] },
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `internal/temperature/device/trend?device_id=${params.device_id}&mode=${params.status}&date_start=${params.datestart}%2017:00:00&date_finish=${params.datefinish}%2017:00:00`,
      }
      useIPA.getInternal(param).then(response => {
        const temperature = {
          rows: response.data.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setData', { ...temperature })
      })
    })
  },
  getAllSparing({ commit }, params) {
    return new Promise((resolve, reject) => {
      const orderBy = params?.orderBy ? `&orderBy=${params.orderBy}` : ''
      const param = {
        status: `internal/sparing/device/trend?device_id=${params.device_id}&mode=${params.status}&date_start=${params.datestart}&date_finish=${params.datefinish}&page=${params.page}&limit=${params.limit}${orderBy}`,
      }
      useIPA.getInternal(param).then(response => {
        const temperature = {
          rows: response.data.data,
          pagination: response.data.pagination,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setDataSparing', { ...temperature })
      })
    })
  },
  getSparingFullData({ commit }, params) {
    return new Promise((resolve, reject) => {
      const orderBy = params?.orderBy ? `&orderBy=${params.orderBy}` : ''
      const param = {
        status: `internal/sparing/device/trend?device_id=${params.device_id}&mode=${params.status}&date_start=${params.datestart}&date_finish=${params.datefinish}${orderBy}`,
      }
      useIPA.getInternal(param).then(response => {
        const temperature = {
          rows: response.data.data,
          pagination: response.data.pagination,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setSparingFullData', { ...temperature })
      })
    })
  },
  getDashboard({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `internal/master/devices/dashboard?latitude=-6.260455&longitude=106.972716&province_id=${params.province_id}&regency_id=${params.regency_id}&district_id=${params.district_id}&device_type_id=${params.device_type_id}&status=${params.device_status}&smile_connection_status=${params.connection_status}`,
      }
      useIPA.getInternal(param).then(response => {
        const temperature = {
          rows: response.data.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setDashboard', { ...temperature })
      })
    })
  },
  getDashboardSparing({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: 'internal/dashboard/sparing?province_id=&regency_id=&district_id=',
      }
      useIPA.getInternal(param).then(response => {
        const temperature = {
          rows: response.data.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setDashboardSparing', { ...temperature })
      })
    })
  },
  getDashboardSparingNew({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: 'internal/dashboard/sparing-data',
      }
      useIPA.getInternal(param).then(response => {
        const temperature = {
          rows: response.data.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setDashboardSparingNew', { ...temperature })
      })
    })
  },
  getDeviceList({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `internal/master/devices/?device_province_id=${params.province_id}&device_regency_id=${params.regency_id}&device_district_id=${params.district_id}&device_site_id=${params.site_id}&status=${params.status}&device_type_id=${params.device_type_id}&page=${params.page || 1}&limit=${params.limit || 10}`,
      }
      useIPA.getInternal(param).then(response => {
        const DeviceList = {
          rows: response.data.data,
        }
        const pagination = {
          limit: parseInt(params.limit) || 10,
          total_items: response.data.pagination ? response.data.pagination.total_items : DeviceList.rows.length,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setDeviceList', { ...DeviceList })
        commit('setPaginationDeviceList', pagination)
      })
    })
  },
  getDeviceListInstallation({ commit }, {
    status = undefined,
    province_id = undefined,
    regency_id = undefined,
    installation_date = undefined,
    device_status = undefined,
    approved_at = undefined,
    page = 1,
    limit = 10,
  }) {
    return new Promise((resolve, reject) => {
      const param = {
        status: 'internal/master/devices/installations',
        params: {
          installation_status: status,
          device_province_id: province_id,
          device_regency_id: regency_id,
          installation_date,
          approved_at,
          device_status,
          page,
          limit,
        },
      }
      useIPA.getInternal(param).then(response => {
        const DeviceList = {
          rows: response.data.data.devices,
        }
        const pagination = {
          limit: parseInt(limit) || 10,
          total_items: response.data.pagination ? response.data.pagination.total_items : DeviceList.rows.length,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
        commit('setDeviceListInstallation', { ...DeviceList })
        commit('setPaginationDeviceListInstallation', pagination)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = new FormData()
      rawData.set('device_id', formData.select_1)
      rawData.set('latitude', formData.text_3)
      rawData.set('longitude', formData.text_4)
      rawData.set('installator_company', formData.text_1)
      rawData.set('installator_name', formData.text_2)
      rawData.set(
        'installation_date',
        moment(formData.date_1.split(' '), 'YYYY-MM-DD').format('YYYY-MM-DD'),
      )
      rawData.set('site_id', formData.select_9)
      rawData.set('update_interval', formData.text_5)
      if (formData.setUpload === 'upload') {
        rawData.append('file_documentation', formData.instalasi)
      } else {
        rawData.set('file_documentation', formData.instalasi)
      }
      if (formData.setUpload2 === 'upload') {
        rawData.append('file_bast', formData.bast)
      } else {
        rawData.set('file_bast', formData.bast)
      }
      if (formData.setUpload3 === 'upload') {
        rawData.append('file_calibration', formData.kalibrasi)
      } else {
        rawData.set('file_calibration', formData.kalibrasi)
      }
      const param = {
        rawData,
        url: 'internal/temperature/device/installation',
        id: formData.id,
      }
      useIPA.postput(param).then(
        response => {
          router.push({ name: 'temperature-device' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        },
      )
    })
  },
  formPostPutConnection({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = new FormData()
      if (formData.setUpload === 'upload') {
        rawData.append('photo', formData.photo)
      } else {
        rawData.set('photo', formData.photo)
      }
      const param = {
        rawData,
        url: `internal/master/devices/installations/${formData.id}`,
        id: null,
      }
      useIPA.postputnoid(param).then(
        response => {
          router.push({ name: 'temperature-installation' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        },
      )
    })
  },
  formUploadInstallation({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = new FormData()
      // rawData.append("photo", formData.photo);
      if (formData.type === 'bast') {
        rawData.append('file_bast', formData.bast)
      } else if (formData.type === 'instalasi') {
        rawData.append('file_documentation', formData.instalasi)
      } else if (formData.type === 'kalibrasi') {
        rawData.append('file_calibration', formData.kalibrasi)
      }

      const param = {
        rawData,
        url: `internal/master/devices/installations/${formData.id}`,
        id: null,
      }
      useIPA.postputnoid(param).then(
        response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        },
      )
    })
  },
  formPostPutEdit({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = new FormData()
      rawData.set('site_id', formData.select_9)
      if (formData.setUploadBast1 === 'upload') {
        rawData.append('photo_bast_1', formData.bast_1)
      } else {
        rawData.set('photo_bast_1', formData.bast_1)
      }
      if (formData.setUploadBast2 === 'upload') {
        rawData.append('photo_bast_2', formData.bast_2)
      } else {
        rawData.set('photo_bast_2', formData.bast_2)
      }
      if (formData.setUploadDoc1 === 'upload') {
        rawData.append('photo_doc_1', formData.file_documentation_1)
      } else {
        rawData.set('photo_doc_1', formData.file_documentation_1)
      }
      if (formData.setUploadDoc2 === 'upload') {
        rawData.append('photo_doc_2', formData.file_documentation_2)
      } else {
        rawData.set('photo_doc_2', formData.file_documentation_2)
      }
      if (formData.setUploadDoc3 === 'upload') {
        rawData.append('photo_doc_3', formData.file_documentation_3)
      } else {
        rawData.set('photo_doc_3', formData.file_documentation_3)
      }
      if (formData.setUploadDoc4 === 'upload') {
        rawData.append('photo_doc_4', formData.file_documentation_4)
      } else {
        rawData.set('photo_doc_4', formData.file_documentation_4)
      }
      if (formData.setUploadDoc5 === 'upload') {
        rawData.append('photo_doc_5', formData.file_documentation_5)
      } else {
        rawData.set('photo_doc_5', formData.file_documentation_5)
      }
      if (formData.setUploadDoc6 === 'upload') {
        rawData.append('photo_doc_6', formData.file_documentation_6)
      } else {
        rawData.set('photo_doc_6', formData.file_documentation_6)
      }
      if (formData.setUploadDoc7 === 'upload') {
        rawData.append('photo_doc_7', formData.file_documentation_7)
      } else {
        rawData.set('photo_doc_7', formData.file_documentation_7)
      }
      if (formData.setUploadDoc8 === 'upload') {
        rawData.append('photo_doc_8', formData.file_documentation_8)
      } else {
        rawData.set('photo_doc_8', formData.file_documentation_8)
      }
      const param = {
        rawData,
        url: `internal/temperature/edit/installation_id?installation_id=${formData.id}`,
        id: null,
      }
      useIPA.postputnoid(param).then(
        response => {
          router.push({ name: 'temperature-installation' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        },
      )
    })
  },
  formPostPutVerification({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        installation_status: 'IN',
      }
      const param = { rawData, url: `internal/master/devices/installations/verify/${formData.id}`, id: null }
      useIPA.postputnoid(param)
        .then(response => {
          router.push({ name: 'temperature-installation' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  formPostPutVerificationNotes({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        installation_status: 'IN',
        installation_note: formData.textarea_1,
      }
      const param = { rawData, url: `internal/master/devices/installations/verify/${formData.id}`, id: null }
      useIPA.postputnoid(param)
        .then(response => {
          router.push({ name: 'temperature-installation' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error)
          }
        })
    })
  },
  formPostPutVerificationReject({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        installation_status: 'RJ',
        installation_note: formData.textarea_1,
      }
      const param = { rawData, url: `internal/temperature/verify/installation?installation_id=${formData.id}`, id: null }
      useIPA.postputnoid(param)
        .then(response => {
          router.push({ name: 'temperature-installation' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  formPostPutVerificationReset({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        installation_status: 'RJ',
      }
      const param = { rawData, url: `internal/master/device/reset/${formData.id}`, id: null }
      useIPA.postputnoid(param)
        .then(response => {
          router.push({ name: 'temperature-installation' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  getByIdInstall({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/devices/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  getByIdInstallation({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/devices/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/device/type/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  getDeviceInstall({ commit }, id) {
    const param = {
      status: 'internal/temperature/data/master/device/installed?site_id=',
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data.data,
      }
      commit('setDeviceInstall', { ...Data })
    })
  },
  getDeviceType({ commit }, id) {
    const param = {
      status: 'internal/master/device-types',
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data.data,
      }
      commit('setDeviceType', { ...Data })
    })
  },
  getDeviceInstallSparing({ commit }, id) {
    const param = {
      status: 'internal/master/devices/installed?site_id=',
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data.data,
      }
      commit('setDeviceInstall', { ...Data })
    })
  },
  getInventory({ commit }, params) {
    const param = {
      status: `internal/temperature/device/inventory/list?province_id=${params.province_id}&regency_id=${params.regency_id}&district_id=`,
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data.data,
      }
      commit('setInventory', { ...Data })
    })
  },
  getReport({ commit }, params) {
    const param = {
      status: `internal/temperature/device/report/list?province_id=${params.province_id}&regency_id=${params.regency_id}&district_id=&date_start=${params.date_start}&date_finish=${params.date_start}`,
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data.data,
      }
      commit('setReport', { ...Data })
    })
  },
  getReportMHD({ commit }, params) {
    const orderBy = params?.orderBy ? `&orderBy=${params.orderBy}` : ''
    const param = {
      status: `internal/sparing/report/data?date_start=${params.date_start}&date_finish=${params.date_finish}&type_report=${params.type_report}&page=${params.page}&limit=${params.limit}&search=${params.search}${orderBy}`,
    }
    useIPA.getInternal(param).then(response => {
      const Data = {
        rows: response.data,
      }
      commit('setReportMHD', { ...Data })
    })
  },
  getReportFullData({ commit }, params) {
    return new Promise((resolve, reject) => {
      const orderBy = params?.orderBy ? `&orderBy=${params.orderBy}` : ''
      const param = {
        status: `internal/sparing/report/data?date_start=${params.date_start}&date_finish=${params.date_finish}&type_report=${params.type_report}${orderBy}`,
      }
      useIPA.getInternal(param).then(response => {
        const Data = {
          rows: response.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setReportFullData', { ...Data })
      })
    })
  },
}

// mutations
const mutations = {
  setData(state, temperature) {
    state.trend = temperature.rows
    state.historical_temperature = temperature.rows.historical_temperature
    state.historical_temperature = temperature.rows.historical_temperature
    state.totalRows_Temperature = temperature.rows.historical_temperature.length
    state.historical_battery = temperature.rows.historical_battery
    state.historical_battery = temperature.rows.historical_battery
    if (temperature.rows.historical_battery) {
      state.totalRows_battery = temperature.rows.historical_battery.length
    }
  },
  setDataSparing(state, temperature) {
    state.trend = temperature.rows
    state.historical_temperature = temperature.rows.historical_sparing
    state.totalRows_Temperature = temperature.pagination.total_items
  },
  setSparingFullData(state, temperature) {
    state.historical_temperature_full = temperature.rows.historical_sparing
  },
  setDeviceList(state, DeviceList) {
    state.deviceList.items = DeviceList.rows.map((element, index) => (
      {
        ...element,
        no: index + 1,
        value_power: `${element.value_power ?? 0}%`,
        signal_strength: `${element.signal_strength ?? 0}%`,
        title: `${element.name} - ${element.serial_number}`,
      }
    ))
    // Only update the active/offline/error counts, not the total rows
    // as that's handled by setPaginationDeviceList
    state.deviceList.totalActive = DeviceList.rows.filter(
      f => f.status === 'IN',
    ).length
    state.deviceList.totalOffline = DeviceList.rows.filter(
      f => f.status === 'ER',
    ).length
    state.deviceList.totalError = DeviceList.rows.filter(
      f => f.status === 'FL',
    ).length
  },
  setDeviceListInstallation(state, DeviceList) {
    const updatedRows = DeviceList.rows.map((element, index) => ({
      ...element,
      no: index + 1,
    }))
    state.deviceListInstallation.items = updatedRows
    // Only update the active/offline/error counts, not the total rows
    // as that's handled by setPaginationDeviceListInstallation
    state.deviceListInstallation.totalActive = DeviceList.rows.filter(
      f => f.device_status === 'IN',
    ).length
    state.deviceListInstallation.totalOffline = DeviceList.rows.filter(
      f => f.device_status === 'ER',
    ).length
    state.deviceListInstallation.totalError = DeviceList.rows.filter(
      f => f.device_status === 'FL',
    ).length
  },
  setDeviceInstall(state, data) {
    for (let i = 0; i < data.rows.length; i++) {
      const option = []
      for (const key in data.rows[i]) {
        if (key === 'device_id') {
          option.value = data.rows[i][key]
        } else if (key === 'device_name') {
          option.title = data.rows[i][key]
        } else if (key === 'device_id') {
          option.oid = data.rows[i][key]
        }
      }
      state.deviceoptions.push({ ...option })
    }
  },
  setDeviceType(state, data) {
    state.devicetypeoptions = []
    for (let i = 0; i < data.rows.length; i++) {
      const option = []
      for (const key in data.rows[i]) {
        if (key === 'id') {
          option.value = data.rows[i][key]
        } else if (key === 'name') {
          option.title = data.rows[i][key]
        } else if (key === 'id') {
          option.oid = data.rows[i][key]
        }
      }
      state.devicetypeoptions.push({ ...option })
    }
  },
  setDashboard(state, dashboard) {
    const deviceListWithNo = dashboard.rows.device_list.map((element, index) => ({
      ...element,
      no: index + 1,
    }))
    state.device_list.items = deviceListWithNo
    state.device_list.totalRows = deviceListWithNo.length
    state.dashboard.items = dashboard.rows
  },
  setInventory(state, dashboard) {
    const updatedRows = dashboard.rows.map((element, index) => ({
      ...element,
      no: index + 1,
    }))
    state.inventory.items = updatedRows
    state.inventory.totalRows = updatedRows.length
  },
  setReport(state, dashboard) {
    const updatedRows = dashboard.rows.map((element, index) => ({
      ...element,
      no: index + 1,
    }))
    state.report.items = updatedRows
    state.report.totalRows = updatedRows.length
  },
  setDashboardSparing(state, dashboard) {
    state.dashboard.sparing = dashboard.rows
  },
  setDashboardSparingNew(state, dashboard) {
    state.dashboard.sparing = dashboard.rows
  },
  setReportMHD(state, dashboard) {
    const updatedData = dashboard.rows.data.map((element, index) => ({
      ...element,
      no: index + 1,
    }))
    state.reportMHD.items = updatedData
    state.reportMHD.items = state.reportMHD.items.map(x => ({
      ...x,
      date_time: moment(x.date_time).format('YYYY-MMM-DD, HH:mm:ss'),
      recorded_at: moment(x.date_time).format('YYYY-MMM-DD, HH:mm:ss'),
      debit: parseFloat(x.debit).toFixed(2),
    }))
    state.reportMHD.totalRows = dashboard.rows.pagination.total_items
  },
  setReportFullData(state, dashboard) {
    state.reportMHD.fullItems = dashboard.rows.data.map((x, index) => ({
      ...x,
      no: index + 1,
      date_time: moment(x.date_time).format('YYYY-MMM-DD, HH:mm:ss'),
      recorded_at: moment(x.date_time).format('YYYY-MMM-DD, HH:mm:ss'),
      debit: parseFloat(x.debit).toFixed(2),
    }))
  },
  setPaginationDeviceList(state, pagination) {
    state.deviceList.perPage = pagination.limit
    state.deviceList.totalRows = pagination.total_items
  },
  setPaginationDeviceListInstallation(state, pagination) {
    state.deviceListInstallation.perPage = pagination.limit
    state.deviceListInstallation.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
